import { put, select, takeLeading, all } from "redux-saga/effects";
import * as actions from "./updatableObjectsActions";
import { request as getObjectsRequest } from "store/api/organization/genericQueryPost/genericQueryPostRequest";
import { getRequestPayload, updateInfoData, UpdatableObjectsGetRequestAction } from "./helpers";

function* UpdatableObjectsGetRequestSaga(action: UpdatableObjectsGetRequestAction) {
  const filterType = action.filterType || "splitTunneling";
  const storeData = yield select((state) => state.updatableObjects);
  const filterData = storeData[filterType];

  if (!filterData.data) {
    try {
      const response = yield getObjectsRequest(getRequestPayload(1, filterType));
      const { data, totalPage } = response;
      const summedData = [...data];

      if (totalPage > 1) {
        const results = yield all(Array.from({ length: totalPage - 1 }, (_, i) => 
          getObjectsRequest(getRequestPayload(i + 2, filterType))
        ));
        results.forEach(element => {
          summedData.push(...element.data);
        });
      }

      const vendorMap = new Map(summedData.map(obj => [obj.vendorId, obj]));
      summedData.forEach(obj => {
        if ((obj.inheritDescription || obj.inheritInfoText || obj.inheritInfoUrl) && obj.vendorParentId) {
          updateInfoData(obj, obj.vendorParentId, vendorMap);
        }
      });

      yield put(actions.requestSuccess(summedData, filterType));
    } catch (error) {
      yield put(actions.requestFailure(error, filterType));
    }
  } else {
    yield put(actions.requestSuccess(filterData.data, filterType));
  }
}

function* saga() {
  yield takeLeading(
    actions.UPDATABLE_OBJECTS_GET_REQUEST,
    UpdatableObjectsGetRequestSaga
  );
}

export default saga;
